import React from 'react'

import NewMemberRegistrationScene from './scenes'

const NewMemberRegistrationMain = ({ location }) => {
  return <NewMemberRegistrationScene location={location} />
}

export default NewMemberRegistrationMain
